/**
 * TTN list page (2026-06-03).
 */
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { tnn, type TnnListItem } from '@/api/tnn';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

export default function TnnPage() {
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['tnn-list'],
    queryFn: () => tnn.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<TnnListItem>[]>(() => [
    { key: 'document_number', header: '№', width: 150, importBadge: true, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    {
      key: 'document_date', header: 'Дата', width: 170,
      sortValue: (r) => r.document_date ?? '',
      cell: (r) => r.document_date ? new Date(r.document_date).toLocaleString('uk-UA') : '',
    },
    { key: 'carrier_name', header: 'Перевізник', sortValue: (r) => r.carrier_name ?? '', cell: (r) => r.carrier_name },
    { key: 'vehicle_plate', header: 'Авто', width: 130, sortValue: (r) => r.vehicle_plate ?? '', cell: (r) => r.vehicle_plate },
    { key: 'driver_full_name', header: 'Водій', sortValue: (r) => r.driver_full_name ?? '', cell: (r) => r.driver_full_name },
    {
      key: 'state', header: 'Стан', width: 110,
      sortValue: (r) => r.state ?? '',
      cell: (r) => {
        const posted = r.state === 'POSTED';
        const label = posted ? '✓ Проведено' : r.state === 'CANCELLED' ? '✗ Скасовано' : 'Чернетка';
        return <span style={{ color: posted ? '#15803d' : '#64748b', fontWeight: posted ? 600 : 400 }}>{label}</span>;
      },
    },
  ], []);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Товарно-транспортні накладні (ТТН)</h2>
        <button className="primary" onClick={() => navigate('/tnn/new')}>
          + Нова ТТН
        </button>
      </div>
      <DataTable<TnnListItem>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає ТТН."
        onRowDoubleClick={(r) => navigate(`/tnn/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
